var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.354 4.354a.5.5 0 000-.708L8.172.464a.5.5 0 10-.708.708L10.293 4 7.464 6.828a.5.5 0 10.708.708l3.182-3.182zM0 4.5h11v-1H0v1z",
    fill: "#949494"
  })));
}

export default __webpack_public_path__ + "./fonts/arrow.400cd7d97123dba7d6e03b38f7f62da4.svg";
export { SvgArrow as ReactComponent };